import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { renderIndustryDataAvailabilityNotice } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/IndustryDataAvailabilityBanner";
import { useDurationSubtitleFilter } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDurationSubtitleFilter";

import { PerformanceOverTimeChart } from "../../PerformanceOverTimeChart";

import { useIndustryPerformanceOverTime } from "./useIndustryPerformanceOverTime";

interface IIndustryPerformanceOverTimeProps {
    category: IFlattenedCategory;
}

export const IndustryPerformanceOverTime = ({ category }: IIndustryPerformanceOverTimeProps) => {
    const { performanceData, hasAdIntelMetrics, isLoading, isError, availability } =
        useIndustryPerformanceOverTime(category);

    const durationSubtitleFilter = useDurationSubtitleFilter();
    const subtitleFilters = useSubtitleFilters("country", "webSource");

    return (
        <PerformanceOverTimeChart
            performanceData={performanceData}
            hasAdIntelMetrics={hasAdIntelMetrics}
            isLoading={isLoading}
            isError={isError}
            subtitleFilters={[durationSubtitleFilter, ...subtitleFilters]}
            controller="advertiser"
            automationId="industry-performance-over-time-widget"
            metricSelectionMode="segmented"
            noticeSlot={renderIndustryDataAvailabilityNotice(availability)}
        />
    );
};
